import script from "./CatalogPublicationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogPublicationSettings.vue?vue&type=script&setup=true&lang=js"

import "./CatalogPublicationSettings.vue?vue&type=style&index=0&id=4d7937b2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7937b2"]])

export default __exports__